import script from "./DepartmentRuleDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentRuleDrawer.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentRuleDrawer.vue?vue&type=style&index=0&id=1a939a84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a939a84"]])

export default __exports__